module.exports = __webpack_public_path__ + "static/media/pzu.e8ea7ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pzu.jpg
// module id = 1106
// module chunks = 0